(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["journal-drawer"] && !Shopify.designMode) return;
  try {
    const JOURNAL_L1_VIEW = 'view=level-one';
    const JOURNAL_L1_ID_KEY = 'journalL1SectionId';
    const JOURNAL_L1_MAP_KEY = 'journalL1Templates';

    function journalDrawerSep(url) {
      return url.indexOf('?') === -1 ? '?' : '&';
    }
    function journalDrawerStoredId() {
      try { return window.localStorage.getItem(JOURNAL_L1_ID_KEY) || ''; } catch (e) { return ''; }
    }
    function journalDrawerStoreId(id) {
      try { window.localStorage.setItem(JOURNAL_L1_ID_KEY, id); } catch (e) { /* private mode */ }
    }
    // Per-article map: { [url]: { own: '<sectionId>' } | { legacy: '<suffix>' } }.
    // `own` = the article's own template contains the L1 section (id cached for the
    // lightweight fetch); `legacy` = the template at that suffix had no L1 section,
    // so discovery is skipped until the article's template assignment changes.
    function journalDrawerReadMap() {
      try { return JSON.parse(window.localStorage.getItem(JOURNAL_L1_MAP_KEY)) || {}; } catch (e) { return {}; }
    }
    function journalDrawerWriteMap(map) {
      try { window.localStorage.setItem(JOURNAL_L1_MAP_KEY, JSON.stringify(map)); } catch (e) { /* private mode */ }
    }

    class JournalDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.inner = this.querySelector('[data-journal-drawer-inner]');
        this.cache = {};
        if (!this.dialog) return;
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-journal-drawer-close]')) {
            this.close();
          }
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.close();
          }
        });
        // Release the page scroll lock on every close path (button, backdrop, Esc).
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('journal-drawer-open');
        });
      }

      async open(url, templateSuffix) {
        if (!url) return;
        if (typeof this.dialog.showModal !== 'function') {
          window.location.href = url;
          return;
        }
        // Open immediately with a loading state so the click feels responsive.
        const token = (this.token || 0) + 1;
        this.token = token;
        this.showLoading();
        this.dialog.showModal();
        // showModal() focuses the close button and browsers draw its focus ring
        // even for pointer opens; move initial focus to the scrollable body
        // instead (keyboard users Tab to reach the close button).
        this.inner.focus({ preventScroll: true });
        document.documentElement.classList.add('journal-drawer-open');

        const markup = await this.resolve(url, templateSuffix);
        // Bail if the drawer was closed or another trigger opened meanwhile.
        if (this.token !== token || !this.dialog.open) return;
        if (!markup) {
          this.close();
          window.location.href = url;
          return;
        }
        this.inner.innerHTML = markup;
        this.inner.scrollTop = 0;
        this.initProducts();
      }

      showLoading() {
        this.inner.innerHTML =
          '<div class="journal-drawer__loading" role="status" aria-label="Loading">' +
          '<span class="journal-drawer__spinner" aria-hidden="true"></span></div>';
      }

      async resolve(url, templateSuffix) {
        if (this.cache[url]) return this.cache[url];
        const suffix = templateSuffix || '';
        const map = journalDrawerReadMap();
        let entry = map[url] || {};
        let result = null;

        // 1. Article's own template, by cached section id (lightweight). A stale id
        //    (template deleted/recreated) 404s here; drop the entry so discovery reruns.
        if (entry.own) {
          const cached = await this.fetchSection(url + journalDrawerSep(url) + 'section_id=' + encodeURIComponent(entry.own), false);
          if (cached && cached.markup) {
            result = cached;
          } else {
            delete map[url];
            journalDrawerWriteMap(map);
            entry = {};
          }
        }

        // 2. Discover the article's own template with a full render. Only worth a request
        //    when the article has an alternate template at all (the default article template
        //    never contains the L1 section) and that suffix wasn't already checked. A 'none'
        //    verdict is remembered per suffix; transient fetch failures are not.
        if (!result && suffix && entry.legacy !== suffix) {
          const own = await this.fetchSection(url, true);
          if (own && own.markup) {
            result = own;
            if (own.id) {
              map[url] = { own: own.id };
              journalDrawerWriteMap(map);
            }
          } else if (own === 'none') {
            map[url] = { legacy: suffix };
            journalDrawerWriteMap(map);
          }
        }

        // 3. Shared level-one template fallback, lightweight then full render.
        if (!result) {
          const base = url + journalDrawerSep(url) + JOURNAL_L1_VIEW;
          const sharedId = journalDrawerStoredId();
          if (sharedId) {
            const cached = await this.fetchSection(base + '&section_id=' + encodeURIComponent(sharedId), false);
            if (cached && cached.markup) result = cached;
          }
          if (!result) {
            const full = await this.fetchSection(base, true);
            if (full && full.markup) {
              result = full;
              if (full.id) journalDrawerStoreId(full.id);
            }
          }
        }

        if (result && result.markup) {
          this.cache[url] = result.markup;
          return result.markup;
        }
        return null;
      }

      // Returns { markup, id } when the L1 section is present, the string 'none' when the
      // page rendered without it, and null on network/HTTP failure. Only 'none' is a
      // trustworthy "this template has no L1 content" signal.
      async fetchSection(fetchUrl, captureId) {
        try {
          const response = await fetch(fetchUrl);
          if (!response.ok) return null;
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const section = doc.querySelector('.journal-l1-article');
          if (!section) return 'none';
          let id = null;
          if (captureId) {
            const wrapper = section.closest('[id^="shopify-section-"]');
            if (wrapper) id = wrapper.id.replace('shopify-section-', '');
          }
          return { markup: section.outerHTML, id: id };
        } catch (error) {
          return null;
        }
      }

      initProducts() {
        // The featured-products carousel is injected after page load, so initialise it via the
        // same hook product-swiper.js uses for AJAX product recommendations.
        if (window.jQuery) {
          window.jQuery(document).trigger('productSwiperInit');
        }
        const refresh = () => {
          const swiperEl = this.inner && this.inner.querySelector('[data-products-swiper]');
          if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.update();
          } else {
            window.dispatchEvent(new Event('resize'));
          }
        };
        requestAnimationFrame(refresh);
        setTimeout(refresh, 250);
      }

      close() {
        if (this.dialog && this.dialog.open) {
          this.dialog.close();
        }
      }
    }

    if (!customElements.get('journal-drawer')) {
      customElements.define('journal-drawer', JournalDrawer);
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-journal-drawer-trigger]');
      if (!trigger) return;
      const drawer = document.querySelector('journal-drawer');
      const url = trigger.getAttribute('data-journal-url');
      if (!drawer || !url) return;
      // With JS the card opens the drawer; without it the anchor navigates to the article (fallback).
      event.preventDefault();
      drawer.open(url, trigger.getAttribute('data-journal-template') || '');
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["journal-filter-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-journal-filter-toggle]');
    if (toggle) {
      const nav = toggle.closest('[data-journal-filter]');
      if (nav) {
        const isOpen = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        // The open menu column aligns under the bar's current item (Figma
        // 3074:22733) - an offset that depends on the L1 label's width, so
        // it has to be measured, not styled.
        const current = nav.querySelector('.journal-filter__toggle-current');
        if (isOpen && current) {
          const indent = current.getBoundingClientRect().left - nav.getBoundingClientRect().left;
          nav.style.setProperty('--journal-filter-indent', indent + 'px');
        }
      }
      return;
    }

    const subToggle = event.target.closest('[data-journal-subnav-toggle]');
    if (subToggle) {
      const item = subToggle.closest('.journal-filter__item--has-children');
      if (item) {
        const isOpen = item.classList.toggle('is-open');
        subToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["journal-masonry-feed"] && !Shopify.designMode) return;
  try {
    (function () {
    function columnCount() {
      if (window.matchMedia('(min-width: 989px)').matches) return 3;
      if (window.matchMedia('(min-width: 768px)').matches) return 2;
      return 1;
    }
    // Columns are filled round-robin by the item's original feed position
    // (data-masonry-index) rather than by measured height: the visual reading
    // order then always matches the published-date order Shopify serves, the
    // distribution is identical at every viewport width, and any shortfall
    // from a partial last row lands in the rightmost column.
    function orderedItems(masonry) {
      var items = Array.prototype.slice.call(masonry.querySelectorAll('.journal-masonry__item'));
      items.sort(function (a, b) {
        return Number(a.dataset.masonryIndex || 0) - Number(b.dataset.masonryIndex || 0);
      });
      return items;
    }
    function layoutMasonry(masonry) {
      var items = orderedItems(masonry);
      var count = columnCount();
      if (masonry._columns && masonry._columns.length === count && masonry._itemCount === items.length) {
        return;
      }
      masonry.classList.add('journal-masonry--js');
      masonry.replaceChildren();
      var columns = [];
      for (var i = 0; i < count; i++) {
        var col = document.createElement('div');
        col.className = 'journal-masonry__col';
        masonry.appendChild(col);
        columns.push(col);
      }
      items.forEach(function (item, index) {
        item.dataset.masonryIndex = String(index);
        columns[index % count].appendChild(item);
      });
      masonry._columns = columns;
      masonry._itemCount = items.length;
    }
    function layoutAll() {
      document.querySelectorAll('.journal-masonry').forEach(layoutMasonry);
    }
    var frame;
    function scheduleLayout() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(layoutAll);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', layoutAll);
    } else {
      layoutAll();
    }
    window.addEventListener('resize', scheduleLayout);

    document.addEventListener('click', async function (event) {
      var link = event.target.closest('.journal-index__more-link');
      if (!link) return;
      event.preventDefault();
      // Ignore re-activation (e.g. keyboard Enter) while a fetch is in flight.
      if (link.getAttribute('aria-busy') === 'true') return;
      var url = link.getAttribute('href');
      var masonry = document.querySelector('.journal-masonry');
      if (!url || !masonry) {
        if (url) window.location.href = url;
        return;
      }
      link.setAttribute('aria-busy', 'true');
      try {
        var response = await fetch(url);
        var markup = await response.text();
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var newItems = Array.prototype.slice.call(parsed.querySelectorAll('.journal-masonry__item'));
        var columns = masonry._columns && masonry._columns.length ? masonry._columns : null;
        newItems.forEach(function (item) {
          var node = document.importNode(item, true);
          if (columns) {
            node.dataset.masonryIndex = String(masonry._itemCount);
            columns[masonry._itemCount % columns.length].appendChild(node);
            masonry._itemCount++;
          } else {
            masonry.appendChild(node);
          }
        });
        var newCount = parsed.querySelector('.journal-index__count');
        var currentCount = document.querySelector('.journal-index__count');
        if (newCount && currentCount) {
          currentCount.textContent = newCount.textContent;
        }
        var nextLink = parsed.querySelector('.journal-index__more-link');
        if (nextLink) {
          link.setAttribute('href', nextLink.getAttribute('href'));
        } else {
          link.remove();
        }
      } catch (error) {
        window.location.href = url;
      }
      link.removeAttribute('aria-busy');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["journal-scroll-pill"] && !Shopify.designMode) return;
  try {
    // The pill lives in two scroll contexts - the direct-link page (window scroll) and
  // the journal drawer (its own inner scroller) - and scroll events don't bubble, so
  // one capture-phase listener on the document covers both, including drawer content
  // injected after load.
  (() => {
    const HIDDEN_CLASS = 'journal-l1-article__scroll--hidden';
    const THRESHOLD = 10;

    const syncScrollPills = () => {
      document.querySelectorAll('.journal-l1-article__scroll').forEach((pill) => {
        const drawerInner = pill.closest('[data-journal-drawer-inner]');
        const offset = drawerInner ? drawerInner.scrollTop : window.scrollY;
        pill.classList.toggle(HIDDEN_CLASS, offset > THRESHOLD);
      });
    };

    document.addEventListener('scroll', syncScrollPills, { capture: true, passive: true });
    // Browsers restore the scroll position on reload/back before this script runs.
    window.addEventListener('load', syncScrollPills);
  })();
  } catch(e) { console.error(e); }
})();

})();
